import { Text } from '@thanx/uikit/text'
import PopoverContent, { Sections } from 'components/PopoverContent'
import { buildTranslate } from 'locales'

const t = buildTranslate('redeem_manager.builder.steps.configuration')

const ModifierPopover = () => {
  const sections: Sections = [
    {
      content: t('modifier_popover.content'),
    },
    {
      title: t('modifier_popover.example'),
      content: (
        <div
          dangerouslySetInnerHTML={{
            __html: t('modifier_popover.example_items'),
          }}
        />
      ),
      contentClassName: 'mt-xs',
    },
    {
      content: t('modifier_popover.footer'),
      contentClassName: 'mt-m',
    },
  ]
  return (
    <Text.BodyText4 className="ml-xs">
      <PopoverContent sections={sections} />
    </Text.BodyText4>
  )
}

export default ModifierPopover
